import { useEffect, useLayoutEffect } from 'react'

// useLayoutEffect on the client (runs before paint), useEffect on the server
// (avoids the SSR warning; layout effects cannot run during server rendering).
export const useIsomorphicLayoutEffect =
    typeof window !== 'undefined' ? useLayoutEffect : useEffect
